<form class="example-form">
	<input type="text"
		#input="matAutocompleteTrigger"
		[ngClass]="inputClass"
		[formControl]="inputControl"
		[matAutocomplete]="dropdownlist"
		[matAutocompletePosition]="'below'"
		[attr.disabled]="disabled ? true : null"
		[attr.placeholder]="placeholder"
		[attr.maxLength]="maxLength"
		(focus)="onInputFocus()" (focusout)="onFocusOut($event)" 
		/>
		
	<mat-autocomplete 
		#dropdownlist="matAutocomplete"
		[class]="panelClass"
		[displayWith]="displayWith"
		(optionSelected)="onOptionSelected($event)"
		>
		
        <mat-option *ngFor="let option of optionsClassic"
        	[disabled]="option.disabled"
        	[class]="option.class"
        	[value]="option.value"
        	>
        	{{ option.label }}
        </mat-option>
        <mat-option *ngFor="let option of optionsHtml"
        	[disabled]="option.disabled"
        	[class]="option.class"
        	[value]="option.value"
        	[innerHtml]="option.label"
        	>
        </mat-option>
	</mat-autocomplete>
</form>